<template>
    <RoomInfo :roomId="roomId" />
</template>

<script>
import RoomInfo from "@/components/room-info/RoomInfo";

export default {
    components: { RoomInfo },
    name: "room-info",
    props: {
        roomId: {
            type: String,
            required: true,
        },
    },
};
</script>
